const awsmobile = {
  "aws_appsync_region": "ap-southeast-2",
  "aws_appsync_authenticationType": "API_KEY",
  "aws_appsync_graphqlEndpoint": "https://cqydujribfeihfvr3thnxu4ltq.appsync-api.ap-southeast-2.amazonaws.com/graphql",
  "aws_appsync_apiKey": "da2-w5mcuxyggnaf3axld7ut5uk25u"
};

export default awsmobile;
